document.querySelectorAll('[slider-d5]').forEach(slider => {
  const arrowsEnabled = slider.getAttribute('slider-arrows') === 'true';
  const paginationEnabled = slider.getAttribute('slider-pagination') === 'true';
  const countEnabled = slider.getAttribute('slider-count') === 'true';

  const track = slider.querySelector('[slider-track-d5]');
  const slides = Array.from(track ? track.querySelectorAll('[slider-slide-d5]') : []);
  const countEl = slider.querySelector('[slider-count-d5]');
  const paginationEl = slider.querySelector('[slider-pagination-d5]');
  const nextBtn = slider.querySelector('[slider-next-d5]');
  const prevBtn = slider.querySelector('[slider-prev-d5]');

  if (!track || slides.length === 0) return;

  if (!arrowsEnabled) {
    if (nextBtn) nextBtn.style.display = 'none';
    if (prevBtn) prevBtn.style.display = 'none';
  }
  if (!paginationEnabled && paginationEl) paginationEl.style.display = 'none';
  if (!countEnabled && countEl) countEl.style.display = 'none';

  const total = slides.length;
  let currentIndex = 0;

  function getTargetScroll(index) {
    return slides[index].offsetLeft - track.offsetLeft;
  }

  function buildPagination() {
    if (!paginationEnabled || !paginationEl) return;
    paginationEl.innerHTML = '';
    slides.forEach((_, i) => {
      const dot = document.createElement('div');
      dot.setAttribute('slide-dot-d5', '');
      if (i === currentIndex) dot.setAttribute('active', '');
      dot.addEventListener('click', () => goTo(i));
      paginationEl.appendChild(dot);
    });
  }

  function updateUI() {
    if (paginationEnabled && paginationEl) {
      paginationEl.querySelectorAll('[slide-dot-d5]').forEach((dot, i) => {
        i === currentIndex ? dot.setAttribute('active', '') : dot.removeAttribute('active');
      });
    }
    if (countEnabled && countEl) countEl.textContent = `${currentIndex + 1} / ${total}`;
    const canScroll = track.scrollWidth > track.clientWidth + 1;
    track.classList.toggle('center', !canScroll);
    if (arrowsEnabled) {
      if (prevBtn) {
        (currentIndex <= 0 || !canScroll)
          ? prevBtn.setAttribute('disabled', '')
          : prevBtn.removeAttribute('disabled');
      }
      if (nextBtn) {
        (currentIndex >= total - 1 || !canScroll)
          ? nextBtn.setAttribute('disabled', '')
          : nextBtn.removeAttribute('disabled');
      }
    }
  }

  function goTo(index) {
    const targetIndex = Math.max(0, Math.min(index, total - 1));
    currentIndex = targetIndex;
    track.scrollTo({ left: getTargetScroll(targetIndex), behavior: 'smooth' });
    updateUI();
  }

  track.addEventListener('scrollend', () => {
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    let closest = atEnd ? total - 1 : 0;
    if (!atEnd) {
      let minDist = Infinity;
      slides.forEach((slide, i) => {
        const dist = Math.abs((slide.offsetLeft - track.offsetLeft) - track.scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
    }
    if (closest !== currentIndex) {
      currentIndex = closest;
      updateUI();
    }
  });

  if (arrowsEnabled) {
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex + 1));
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
  }

  window.addEventListener('resize', () => {
    track.scrollLeft = getTargetScroll(currentIndex);
    updateUI();
  });

  buildPagination();
  updateUI();
});